/**
 * מקטע #app-download-progress — זיהוי מכשיר, פס התקדמות, כפתור חנות.
 *
 * דסקטופ (לא iOS/Android): המקטע מוסתר.
 * מובייל: פס מלא + כפתור חנות מיד.
 *
 * הערה: לא לשלב d-inline-flex עם d-none על אותו אלמנט (שניהם !important ב-Bootstrap).
 */
(function () {
  'use strict';

  /**
   * @returns {'ios' | 'android' | 'other'}
   */
  function detectPlatform() {
    const ua = navigator.userAgent || '';
    if (/Android/i.test(ua)) return 'android';
    if (/iPad|iPhone|iPod/i.test(ua)) return 'ios';
    if (typeof navigator.platform === 'string' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return 'ios';
    }
    return 'other';
  }

  function applyStoreHref(anchor, url) {
    if (!anchor) return;
    const trimmed = (url || '').trim();
    if (trimmed) anchor.setAttribute('href', trimmed);
  }

  function revealActionsRow(row) {
    if (row) row.classList.remove('d-none');
  }

  /** מסיר d-none בלבד — ה-display של inline-flex מגיע מ-SCSS :not(.d-none) */
  function revealCtaButton(btn) {
    if (!btn) return;
    btn.classList.remove('d-none');
  }

  function initAppDownloadProgress() {
    const root = document.getElementById('app-download-progress');
    if (!root) return;

    const platform = detectPlatform();

    if (platform === 'other') {
      root.classList.add('d-none');
      root.setAttribute('hidden', 'true');
      return;
    }

    root.classList.remove('d-none');
    root.removeAttribute('hidden');

    const iosUrl = root.dataset.iosUrl || '';
    const androidUrl = root.dataset.androidUrl || '';

    const bar = root.querySelector('.app-download__progress-bar-fill');
    const actionsRow = root.querySelector('.app-download__progress-actions');
    const btnIos = root.querySelector('.app-download__progress-cta--ios');
    const btnAndroid = root.querySelector('.app-download__progress-cta--android');

    applyStoreHref(btnIos, iosUrl);
    applyStoreHref(btnAndroid, androidUrl);

    function finishAndShowCta() {
      revealActionsRow(actionsRow);
      if (platform === 'ios') {
        revealCtaButton(btnIos);
      } else {
        revealCtaButton(btnAndroid);
      }
    }

    if (bar) {
      bar.style.width = '100%';
      bar.setAttribute('aria-valuenow', '100');
    }
    finishAndShowCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppDownloadProgress, { once: true });
  } else {
    initAppDownloadProgress();
  }
})();
